import React, { useState } from 'react';
import { message } from 'antd';
import { StyledButtonContainer, StyledContainer, StyledCountText } from './styles';
import { useDownloadSettlementExcel } from '../../hooks';
import { SettlementItemsFindAndDownloadExcelRequestBodySearchOptionsDto } from '../../../../types/api/settlement-items';
import SettlementBulkModal from '../SettlementBulkModal/SettlementBulkModal';
import { SettlementItem } from '../../types/columns';
import Button from '../../../../components/Button';

type Props = {
  totalCount: number;
  request: SettlementItemsFindAndDownloadExcelRequestBodySearchOptionsDto;
  bulkItems: SettlementItem[];
  onResetFilter: () => void;
  type: 'ready' | 'completed' | 'hold';
};

const SettlementListToolbar = ({ request, totalCount, bulkItems, onResetFilter, type }: Props): JSX.Element => {
  const { isLoading, mutate } = useDownloadSettlementExcel(request);

  const [openModalType, setOpenModalType] = useState('');

  const openHoldModal = (): void => {
    setOpenModalType('보류');
  };

  const openCompleteModal = (): void => {
    setOpenModalType('완료');
  };

  const closeModal = (): void => {
    setOpenModalType('');
  };

  return (
    <>
      {openModalType === '보류' && (
        <SettlementBulkModal open={openModalType === '보류'} bulkItems={bulkItems} onCancel={closeModal} type="보류" />
      )}
      {openModalType === '완료' && (
        <SettlementBulkModal open={openModalType === '완료'} bulkItems={bulkItems} onCancel={closeModal} type="완료" />
      )}
      <StyledContainer>
        <StyledCountText>
          <span>{totalCount}</span>건이 조회되었습니다.
        </StyledCountText>
        <StyledButtonContainer>
          {['ready'].includes(type) && (
            <Button
              color="primary"
              onClick={(): void => {
                if (bulkItems.length === 0) {
                  message.error('정산 일괄 처리 할 데이터가 없습니다.');
                  return;
                }
                openHoldModal();
              }}
              text="정산 일괄 보류"
            />
          )}
          {['ready', 'hold'].includes(type) && (
            <Button
              color="primary"
              onClick={(): void => {
                if (bulkItems.length === 0) {
                  message.error('정산 일괄 처리 할 데이터가 없습니다.');
                  return;
                }
                openCompleteModal();
              }}
              text="정산 일괄 완료"
            />
          )}
          <Button
            disabled={isLoading}
            color="light"
            onClick={(): void => {
              if (totalCount === 0) {
                message.error('엑셀을 다운로드할 데이터가 없습니다.');
                return;
              }
              mutate();
            }}
            text="엑셀 다운로드"
          />

          <Button color="light" onClick={onResetFilter} text="필터 초기화" />
        </StyledButtonContainer>
      </StyledContainer>
    </>
  );
};

const Placeholder = ({ type }: Pick<Props, 'type'>): JSX.Element => {
  return (
    <StyledContainer>
      <StyledCountText>
        <span>{0}</span>건이 조회되었습니다.
      </StyledCountText>
      <StyledButtonContainer>
        {['ready'].includes(type) && (
          <Button
            color="primary"
            onClick={(): void => {
              message.error('정산 일괄 처리 할 데이터가 없습니다.');
            }}
            text="정산 일괄 보류"
          />
        )}
        {['ready', 'hold'].includes(type) && (
          <Button
            color="primary"
            onClick={(): void => {
              message.error('정산 일괄 처리 할 데이터가 없습니다.');
            }}
            text="정산 일괄 완료"
          />
        )}
        <Button
          color="light"
          onClick={(): void => {
            message.error('엑셀을 다운로드할 데이터가 없습니다.');
          }}
          text="엑셀 다운로드"
        />
        <Button color="light" text="필터 초기화" />
      </StyledButtonContainer>
    </StyledContainer>
  );
};

SettlementListToolbar.Placeholder = Placeholder;

export default SettlementListToolbar;
